import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from 'components/modals/ConfirmationModal';

import { toggleDestroyModal } from 'redux/actions/destroyModalActions';


class DestroyModal extends React.Component {
  static propTypes = {
    funcToExecute: PropTypes.func.isRequired, // redux action to execute during destroy
    destroyModal: PropTypes.shape({
      objectIdToDestroy: PropTypes.oneOfType([ // because it could be also uuid
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      objectNameToDestroy: PropTypes.string.isRequired, // name to display during user prompt
      isOpen: PropTypes.bool.isRequired,
    }).isRequired,
    onSuccess: PropTypes.func,
    toggleDestroyModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    onSuccess: null,
  };

  handleDestroy = async () => {
    const { funcToExecute, destroyModal, onSuccess } = this.props;
    await funcToExecute(destroyModal.objectIdToDestroy, true);
    await onSuccess(); // success callback
  }

  render() {
    const { objectNameToDestroy, isOpen } = this.props.destroyModal;
    return (
      <ConfirmationModal
        open={isOpen}
        onBackdropClick={() => this.props.toggleDestroyModal()}
        title="Delete item"
        confirmLabel="Delete"
        onConfirmClick={() => this.handleDestroy()}
        onCancelClick={() => this.props.toggleDestroyModal()}
      >
        Are you sure you want to delete
        <span className="volt-modal--stressed">&nbsp;{ objectNameToDestroy }&nbsp;</span>?
      </ConfirmationModal>
    );
  }
}


export default connect(
  state => ({ destroyModal: state.destroyModal }),
  { toggleDestroyModal },
)(DestroyModal);
